import React, { useContext, useState } from 'react';

import { BtnContainer } from './styles';
import { ContextRenegociacao } from '../../../../services/renegociacao';
import { Spinner } from '../../../StyledComponent';
import { getExpirationDateFirstParcell } from '../expirationDateFirstParcell';

const BtnAprovacao = ({
  handleShowSimulacao,
  onAprovacao,
  concordo,
  tema,
  contratoSelecionado,
  regras,
}) => {
  const { postRenegociacaoUAU, simulacaoResult } =
    useContext(ContextRenegociacao);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const msgErroNaoFoiPossivelRenegociar =
    'Não foi possível prosseguir com a Renegociação. Entre em contato com a central de relacionamento no número (31) 4002-2600.';

  const {
    Valor_Parcela_Pos_Habitese,
    Quantidade_Parcela_Pos_Habitese,
    Juros_Parcela_Pos_Habitese,
    Valor_Parcela_Sem_Juros,
  } = simulacaoResult;

  const enviarRenegociacao = async () => {
    setLoading(true);

    try {
      await postRenegociacaoUAU({
        IdVenda: contratoSelecionado?.contrato?.idVenda,
        IdVendaCarteira: contratoSelecionado?.contrato?.idVendaCarteira,
        Empresa:
          contratoSelecionado?.contrato?.empresaVendaCarteira ||
          contratoSelecionado?.contrato?.empresa,
        Obra:
          contratoSelecionado?.contrato?.obraVendaCarteira ||
          contratoSelecionado?.contrato?.obra,
        NumeroVenda:
          contratoSelecionado?.contrato?.numeroVendaVendaCarteira ||
          contratoSelecionado?.contrato?.numeroVenda,
        Valor_Entrada: regras?.entrada,
        Data_Vencimento_Entrada: regras?.vencimentoEntrada.date,
        Data_Vencimento_Primeira_Parcela: getExpirationDateFirstParcell(regras),
        IdContratoCliente: contratoSelecionado?.contrato?.idContratoCliente,
        Valor_Parcela_Pos_Habitese,
        Quantidade_Parcela_Pos_Habitese,
        Juros_Parcela_Pos_Habitese,
        Valor_Parcela_Sem_Juros,
      });
      onAprovacao();
    } catch (e) {
      console.error(e);
      setLoading(false);
      setError(true);
    }
  };

  return (
    <>
      <BtnContainer tema={tema}>
        <button
          onClick={handleShowSimulacao}
          disabled={isLoading}
          id={'btnVoltar'}
        >
          VOLTAR
        </button>
        <button
          disabled={!concordo || isLoading || error}
          onClick={() => {
            enviarRenegociacao().catch((e) => console.error(e));
          }}
          id={'btnAprovarRenegociacao'}
        >
          <span>APROVAR MINHA RENEGOCIAÇÃO</span>
          {isLoading && <Spinner />}
        </button>
      </BtnContainer>
      {error && (
        <p style={{ color: '#be2f25' }}>{msgErroNaoFoiPossivelRenegociar}</p>
      )}
    </>
  );
};

export default BtnAprovacao;
